import { render, staticRenderFns } from "./MagentoContent.vue?vue&type=template&id=6ca2c603&"
import script from "./MagentoContent.vue?vue&type=script&lang=js&"
export * from "./MagentoContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports